var _rect, _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTokenWithBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 7,
    fill: "#F1F1F9"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 13V11C6 8 8 6 11 6H21C24 6 26 8 26 11V13",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6 19V21C6 24 8 26 11 26H21C24 26 26 24 26 21V19",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7602 10.2901L11.5602 12.0701C10.8402 12.4701 10.2402 13.4801 10.2402 14.3101V17.7001C10.2402 18.5301 10.8302 19.5401 11.5602 19.9401L14.7602 21.7201C15.4402 22.1001 16.5602 22.1001 17.2502 21.7201L20.4502 19.9401C21.1702 19.5401 21.7702 18.5301 21.7702 17.7001V14.3101C21.7702 13.4801 21.1802 12.4701 20.4502 12.0701L17.2502 10.2901C16.5602 9.90006 15.4402 9.90006 14.7602 10.2901Z",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7002 13.26L16.0002 16.33L21.2602 13.28",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M16 21.7701V16.3201",
    stroke: "#005DFF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTokenWithBg);
export default __webpack_public_path__ + "static/media/token-with-bg.3b8cd4e13c12e94abf8de719895da311.svg";
export { ForwardRef as ReactComponent };